module Meevo.Plugins.Services {
    "use strict";

    export class ResourcesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Resource> {
        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected trackingService?: Meevo.Components.Tracking.ITrackingService) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

        }

        preDelete = (context: any, items: any[], index: number): boolean => {
            const model = context.sections[0].model;
            const resourseItem = context.sections[3].model;

            var stepResourceExist = model.serviceSteps.find(a => a.stepType == Meevo.Model.ServiceStepTypeEnum.Resource);
            if (stepResourceExist != null && resourseItem.resources.length == 1) {
                this.modalService.alert('MESSAGE_LAST_RESOURCE_ON_SERVICE', Meevo.Components.Modal.ModalTranslationModes.Translate).then(Response => Response)
                return false;

            }
            return true;
        }
    }
}